import { ResourceContainer } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';
import { Input } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';
import { Text2D } from 'ohzi-core';

import { BufferGeometry, Color, DoubleSide, Line, LineBasicMaterial, Vector3, VideoTexture } from 'three';
import { LinearFilter } from 'three';
import { RGBFormat } from 'three';
import { MeshBasicMaterial } from 'three';
import { Raycaster } from 'three';

export default class WallsManager
{
  constructor()
  {
    this.left_walls = [];
    this.right_walls = [];

    this.walls_with_labs = [];
    this.walls_with_labs_meshes = [];

    this.current_wall_i = 0;
    this.raycasted_wall = undefined;
    this.is_wall_opened = false;

    this.hall_size = 0;

    this.raycaster = new Raycaster();
  }

  start(wall_name)
  {
    let labs = ResourceContainer.get_resource('labs');
    let amount_of_walls = (labs.length * 2) + 2;

    this.__init_walls(wall_name, 'left', this.left_walls, amount_of_walls, 35);
    this.__init_walls(wall_name, 'right', this.right_walls, amount_of_walls, -35);

    // this.initial_left_x_pos = this.left_walls[0].position.x;
    // this.initial_right_x_pos = this.right_walls[0].position.x;

    this.__setup_labs();
  }

  update()
  {
    this.raycaster.setFromCamera(Input.NDC, CameraManager.current);
    const intercepts = this.raycaster.intersectObjects(this.walls_with_labs_meshes);
    this.raycasted_wall = undefined;

    for (let i = 0; i < this.walls_with_labs.length; i++)
    {
      if (intercepts.length > 0)
      {
        const wall = this.walls_with_labs[i];

        if (wall.obj.children[0] === intercepts[0].object)
        {
          // Distance between camera and wall
          let distance = (Math.abs(CameraManager.current.position.z - wall.obj.position.z + 25)) / 20;

          if (distance < 1.1 && (wall.is_opened || !this.is_wall_opened))
          {
            wall.on_hover_enter();
            this.raycasted_wall = wall;
          }
          else
          {
            wall.on_hover_leave();
          }
        }
        else
        {
          wall.on_hover_leave();
        }
      }

      this.walls_with_labs[i].update();
    }

    for (let i = 0; i < this.left_walls.length; i++)
    {
      this.left_walls[i].update();
      this.right_walls[i].update();
    }
  }

  __setup_labs()
  {
    let labs = ResourceContainer.get_resource('labs');

    for (let i = 0; i < labs.length; i++)
    {
      let wall = this.__get_next_wall(i);

      wall.set_id(labs[i].id);

      let sibling = wall.type === 'left' ? this.right_walls[wall.row_index] : this.left_walls[wall.row_index];
      wall.set_sibling(sibling);

      this.__setup_video(wall, labs[i].id);
      this.__setup_label(wall, labs[i]);

      this.walls_with_labs.push(wall);
      this.walls_with_labs_meshes.push(wall.obj.children[0]);
    }
  }

  __setup_label(wall, lab, text_pivot, text_position)
  {
    let text = new Text2D(lab.name, '150px Montserrat Black', '#ffffff', text_pivot);

    text.position.copy(text_position);

    text.size = 7;
    // text.rotation.y = wall.type === 'left' ? 3.14 : 0;
    text.rotation.y = 3.14;

    wall.set_text(text);
    SceneManager.current.add(text);
  }

  __setup_video(wall, lab_id)
  {
    let video = document.querySelector(`.video__${lab_id}`);
    let texture = new VideoTexture(video);
    texture.flipY = false;

    texture.minFilter = LinearFilter;
    texture.magFilter = LinearFilter;
    texture.format = RGBFormat;

    wall.video = video;
    video.load();

    wall.obj.children[0].material = new this.MaterialKlass();
    wall.obj.children[0].material.set_texture(texture);
    // wall.obj.children[0].material.opacity = 0.8;
    wall.obj.children[0].material.transparent = true;
  }

  __get_next_wall(i)
  {
    let next_wall = undefined;

    this.current_wall_i += 2;

    if (i % 2)
    {
      next_wall = this.left_walls[this.current_wall_i];
    }
    else
    {
      next_wall = this.right_walls[this.current_wall_i];
    }

    return next_wall;
  }

  __init_walls({
    wall_name,
    type,
    walls,
    amount,
    distance_from_center,
    distance_between_walls,
    background_names,
    light_names,
    WallKlass
  })
  {
    let current_z_position = -50;

    for (let i = 0; i < amount; i++)
    {
      let wall_obj = ResourceContainer.get_resource(wall_name).scene.clone().children[0].clone();

      for (let j = 0; j < background_names.length; j++)
      {
        let glass_material = new MeshBasicMaterial();
        glass_material.opacity = 0.8;
        glass_material.transparent = true;
        glass_material.color = new Color('#000000');

        wall_obj.getObjectByName(background_names[j]).material = glass_material;
      }

      for (let j = 0; j < light_names.length; j++)
      {
        let light = wall_obj.getObjectByName(light_names[j]);

        light.material = new MeshBasicMaterial();
        light.material.color.set('#ffffff');
        light.material.side = DoubleSide;
        light.material.transparent = true;
        light.material.opacity = 1;
      }

      current_z_position += distance_between_walls;

      SceneManager.current.add(wall_obj);
      // wall_obj.position.set(x_initial_position, 0, current_z_position += distance_between_walls);

      this.__set_wall_position(wall_obj, distance_from_center, current_z_position);
      // wall_obj.position.set(0, x_initial_position, current_z_position += 15);
      // wall.rotation.y = type === 'left' ? 0 : -3.14;

      const material = new LineBasicMaterial({
        color: 0xffffff
      });

      material.transparent = true;
      material.opacity = 1;

      const points = [];
      let x_pos = type === 'left' ? 20 : -20;

      points.push(new Vector3(x_pos, 0, 0));
      points.push(new Vector3(x_pos, 40, 0));

      const geometry = new BufferGeometry().setFromPoints(points);

      const line = new Line(geometry, material);
      line.name = 'line';

      wall_obj.add(line);

      let initial_x_or_y_pos = this.__get_initial_x_or_y(wall_obj);

      let wall = new WallKlass(wall_obj, type, initial_x_or_y_pos, i);

      walls.push(wall);
    }

    this.hall_size = current_z_position;
  }

  __set_wall_position()
  {
    console.error('abstract method');
  }

  __get_initial_x_or_y(wall_obj)
  {
    console.error('abstract method');
  }
}
